var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPresent = function SvgPresent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 26c7.18 0 13-5.82 13-13S20.18 0 13 0 0 5.82 0 13s5.82 13 13 13Z",
    fill: "#E23026"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.262 14.563H6.816v6.588h5.446v-6.588ZM19.184 14.563h-5.446v6.588h5.446v-6.588ZM12.263 10.435h-6.36v2.547h6.36v-2.547ZM20.098 10.435h-6.36v2.547h6.36v-2.547ZM18.236 5.41c-.492-.72-1.318-1-2.284-.772-1.054.246-2.248 1.124-2.986 2.424-.738-1.3-1.915-2.178-2.987-2.424-.966-.229-1.81.053-2.284.773-1.142 1.686.334 3.478 1.283 4.198l.158.123h7.66l.157-.123c.932-.72 2.407-2.512 1.283-4.198ZM9.558 8.504c-.405-.37-1.494-1.458-.861-2.407.193-.281.527-.369.984-.264.983.229 2.108 1.265 2.547 2.67h-2.67Zm6.798 0h-2.688c.44-1.406 1.564-2.425 2.548-2.67.474-.106.808-.018.983.263.65.949-.439 2.038-.843 2.407Z",
    fill: "#fff"
  })));
};
export default SvgPresent;